<div class='spinner-wrapper'>
    <img class='main-spinner-legacy' src='assets/image/browser/spinner.gif' alt='loading' />
    <svg class='main-spinner' x='0' y='0' viewBox='0 0 40 40'>
        <circle cx='20' cy='20' r='18'></circle>
    </svg>
</div>
